module.exports = __webpack_public_path__ + "img/ennetix-xtend-traffic-table.639ba79f.png";